import HelpIcon from './component.jsx'
export default HelpIcon
